import {
  GET_ACTUALITY,
  GET_ACTUALITY_SUCCESS,
  GET_ACTUALITY_BY_ID,
  GET_ACTUALITY_BY_ID_SUCCESS,
  POST_ACTUALITY,
  POST_ACTUALITY_SUCCESS,
  POST_FILE_ACTUALITY,
  POST_FILE_ACTUALITY_SUCCESS,
  PATCH_ACTUALITY,
  PATCH_ACTUALITY_SUCCESS,
  ARCHIVED_ACTUALITY,
  ARCHIVED_ACTUALITY_SUCCESS,
  DELETE_ACTUALITY,
  DELETE_ACTUALITY_SUCCESS,
  GET_GOVERNANCE,
  GET_GOVERNANCE_SUCCESS,
  GET_GOVERNANCE_BY_ID,
  GET_GOVERNANCE_BY_ID_SUCCESS,
  POST_GOVERNANCE,
  POST_GOVERNANCE_SUCCESS,
  PATCH_GOVERNANCE,
  PATCH_GOVERNANCE_SUCCESS,
  DELETE_GOVERNANCE,
  DELETE_GOVERNANCE_SUCCESS,
  GET_DOCUMENT_SOLLICITE,
  GET_DOCUMENT_SOLLICITE_SUCCESS,
  GET_DOCUMENTS_WAIT_VALIDATION,
  GET_DOCUMENTS_WAIT_VALIDATION_SUCCESS,
  GET_DOCUMENTS_BY_CONTROL_ID,
  GET_DOCUMENTS_BY_CONTROL_ID_SUCCESS,
  PATCH_DOCUMENT_SOLLICITE,
  DELETE_DOCUMENT_SOLLICITE,
  CONFIRM_DOCUMENTS_ADDED_BY_CLIENT,
  VALIDATE_DOCUMENT_SOLLICITE,
  REJECT_DOCUMENT_SOLLICITE,
  GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS,
  GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS,
  SET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS,
  SET_LOADER_DATA,
  GET_DOCUMENTS_ASSOCIATE_RESPONSE,
  GET_DOCUMENTS_ASSOCIATE_RESPONSE_SUCCESS,
  POST_DOCUMENTS_ASSOCIATE_RESPONSE,
  POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK,
  POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK_V2,
  DELETE_DOCUMENT_ASSOCIATE_BY_ID,
} from "./constants"
//***************************** ACTUALITY *******************************
export function getActualityAction(payload) {
  return {
    type: GET_ACTUALITY,
    payload: payload,
  }
}

export function getActualitySuccess(payload) {
  return {
    type: GET_ACTUALITY_SUCCESS,
    payload: payload,
  }
}

export function getActualityByIdAction(payload) {
  return {
    type: GET_ACTUALITY_BY_ID,
    payload: payload,
  }
}

export function getActualityByIdSuccess(payload) {
  return {
    type: GET_ACTUALITY_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function postActualityAction(payload) {
  return {
    type: POST_ACTUALITY,
    payload: payload,
  }
}

export function postActualitySuccess(payload) {
  return {
    type: POST_ACTUALITY_SUCCESS,
    payload: payload,
  }
}

export function postFilesActualityAction(payload) {
  return {
    type: POST_FILE_ACTUALITY,
    payload: payload,
  }
}

export function postFilesActualitySuccessAction(payload) {
  return {
    type: POST_FILE_ACTUALITY_SUCCESS,
    payload: payload,
  }
}

export function patchActualityAction(payload) {
  return {
    type: PATCH_ACTUALITY,
    payload: payload,
  }
}

export function patchActualitySuccess(payload) {
  return {
    type: PATCH_ACTUALITY_SUCCESS,
    payload: payload,
  }
}

export function archivedActualityAction(payload) {
  return {
    type: ARCHIVED_ACTUALITY,
    payload: payload,
  }
}

export function archivedActualitySuccess(payload) {
  return {
    type: ARCHIVED_ACTUALITY_SUCCESS,
    payload: payload,
  }
}

export function deleteActualityAction(payload) {
  return {
    type: DELETE_ACTUALITY,
    payload: payload,
  }
}

export function deleteActualitySuccess(payload) {
  return {
    type: DELETE_ACTUALITY_SUCCESS,
    payload: payload,
  }
}
//**************************** GOVERNANCE *******************************
export function getGovernanceAction(payload) {
  return {
    type: GET_GOVERNANCE,
    payload: payload,
  }
}

export function getGovernanceSuccess(payload) {
  return {
    type: GET_GOVERNANCE_SUCCESS,
    payload: payload,
  }
}

export function getGovernanceByIdAction(payload) {
  return {
    type: GET_GOVERNANCE_BY_ID,
    payload: payload,
  }
}

export function getGovernanceByIdSuccess(payload) {
  return {
    type: GET_GOVERNANCE_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function postGovernanceAction(payload) {
  return {
    type: POST_GOVERNANCE,
    payload: payload,
  }
}

export function postGovernanceSuccess(payload) {
  return {
    type: POST_GOVERNANCE_SUCCESS,
    payload: payload,
  }
}

export function patchGovernanceAction(payload) {
  return {
    type: PATCH_GOVERNANCE,
    payload: payload,
  }
}

export function patchGovernanceSuccess(payload) {
  return {
    type: PATCH_GOVERNANCE_SUCCESS,
    payload: payload,
  }
}

export function deleteGovernanceAction(payload) {
  return {
    type: DELETE_GOVERNANCE,
    payload: payload,
  }
}

export function deleteGovernanceSuccess(payload) {
  return {
    type: DELETE_GOVERNANCE_SUCCESS,
    payload: payload,
  }
}
//************************ DOCUMENT_SOLLICITE ***************************
export function getDocumentsAction(payload) {
  return {
    type: GET_DOCUMENT_SOLLICITE,
    payload: payload,
  }
}

export function getDocumentsSuccessAction(payload) {
  return {
    type: GET_DOCUMENT_SOLLICITE_SUCCESS,
    payload: payload,
  }
}

export function getDocumentsWaitValidationAction(payload) {
  return {
    type: GET_DOCUMENTS_WAIT_VALIDATION,
    payload: payload,
  }
}

export function getDocumentsWaitValidationSuccessAction(payload) {
  return {
    type: GET_DOCUMENTS_WAIT_VALIDATION_SUCCESS,
    payload: payload,
  }
}

export function getDocumentsByControlIdAction(payload) {
  return {
    type: GET_DOCUMENTS_BY_CONTROL_ID,
    payload: payload,
  }
}

export function getDocumentsByControlIdSuccessAction(payload) {
  return {
    type: GET_DOCUMENTS_BY_CONTROL_ID_SUCCESS,
    payload: payload,
  }
}

export function patchDocumentSolliciteAction(payload) {
  return {
    type: PATCH_DOCUMENT_SOLLICITE,
    payload: payload,
  }
}

export function deleteDocumentSolliciteAction(payload) {
  return {
    type: DELETE_DOCUMENT_SOLLICITE,
    payload: payload,
  }
}

export function confirmDocumentsAddedByClientAction(payload) {
  return {
    type: CONFIRM_DOCUMENTS_ADDED_BY_CLIENT,
    payload: payload,
  }
}

export function validateDocumentSolliciteAction(payload) {
  return {
    type: VALIDATE_DOCUMENT_SOLLICITE,
    payload: payload,
  }
}

export function rejectDocumentSolliciteAction(payload) {
  return {
    type: REJECT_DOCUMENT_SOLLICITE,
    payload: payload,
  }
}

//************************* DOCUMENTS ASSOCIATE RESPONE CONTROL ****************************
export function postDocumentsAssociateResponseAction(payload) {
  return {
    type: POST_DOCUMENTS_ASSOCIATE_RESPONSE,
    payload: payload,
  }
}

export function postDocumentAssociateResponseMappingRiskAction(payload) {
  return {
    type: POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK,
    payload: payload,
  }
}

export function postDocumentAssociateResponseAction(payload) {
  return {
    type: POST_DOCUMENT_ASSOCIATE_RESPONSE_MAPPING_RISK_V2,
    payload: payload,
  }
}

export function getDocumentsAssociateResponseAction(payload) {
  return {
    type: GET_DOCUMENTS_ASSOCIATE_RESPONSE,
    payload: payload,
  }
}

export function getDocumentsAssociateResponseSuccessAction(payload) {
  return {
    type: GET_DOCUMENTS_ASSOCIATE_RESPONSE_SUCCESS,
    payload: payload,
  }
}

export function deleteDocumentAssociateByIdAction(payload) {
  return {
    type: DELETE_DOCUMENT_ASSOCIATE_BY_ID,
    payload: payload,
  }
}
//************************* CONTROL_ARCHIVED ****************************
export function getControlPlanWithControlsArchivedAction(payload) {
  return {
    type: GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS,
    payload: payload,
  }
}

export function getControlPlanWithControlsArchivedSuccessAction(payload) {
  return {
    type: GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS,
    payload: payload,
  }
}

export function setControlPlanWithControlsArchivedAction(payload) {
  return {
    type: SET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS,
    payload: payload,
  }
}

// LOADER
export function setLoaderDataAction(payload) {
  return {
    type: SET_LOADER_DATA,
    payload: payload,
  }
}
